// react
import React, { useEffect, useState, useRef } from "react";
// internal
import GetTrad from "./../../components/utils/GetTrad"
// utils
import getTrad from "./../../utils/getTrad"
// style
import "./Popup.css"

const Popup = (props) => {

	const videoRef = useRef();

	const [section, setSection] = useState("")
	const [name, setName] = useState("")
	const [text, setText] = useState("")
	const [type, setType] = useState(null)
	const [img, setImg] = useState("")
	const [video, setVideo] = useState("")
	const [url, setUrl] = useState(null)

	let popupClose = () => {
		videoRef.current && videoRef.current.pause();
		props.setPopup(null)
		setUrl(null)
	}

	useEffect(() => {

		if(props.content){
			for(let p of props.content.products){
				if(p.id === props.popup){
					for(let s of props.content.sections){
						if(s.id === p.section){
							setSection(s.name[props.lang])
						}
					}
					setName(p.name[props.lang])
					setType(p.type)
					if(p.type === "img"){
						console.log(p.img)
						setImg(p.img)
						setText(p.content[props.lang])
					}else if(p.type === "video"){
						setVideo(p.video[props.lang])
						setText(p.content[props.lang])
					}
					if(p.hasOwnProperty("link")){
						setUrl(p.link[props.lang])
					}else{
						setUrl(null)
					}
				}
			}
		}
	}, [props.content, props.popup, props.lang])

	return (
		<React.Fragment>
			<div
				className="popup-container"
				onClick={() => popupClose()}
				style={{
					display: props.popup !== null ? "block" : "none"
				}}
			>
			</div>
			<div className="popup"
				style={{
					display: props.popup !== null ? "block" : "none"
				}}
			>
				<div className="popup-close" onClick={() => popupClose()}></div>
				<div className="popup-content">
					<div className="popup-content-size">
						<h2 className="tsv5">{section}</h2>
						<h1 className="robotobold">{name}</h1>
						<span className="popup-content-separator"></span>
						<p className="popup-content-text robotoregular" dangerouslySetInnerHTML={ {__html: text} }></p>
						{url && <a target={"_blank"} href={url} className="popup-btn tsv7"><GetTrad id="popupbtn" lang={props.lang} /></a>}
					</div>
				</div>
				<div className="popup-media">
					{type === "img" ? <div
						className="popup-img"
						style={{
							backgroundImage:"url('"+img+"')"
						}}
					></div> : null}
					{type === "video" ? 
						<video ref={videoRef} id="videoPlayer" className="popup-video" controls autoPlay="autoplay" src={video}></video>
						: null}
				</div>
				<div className="popup-content-mobile">
					{url && <a target={"_blank"} href={url} className="popup-btn popup-btn-vertical tsv7"><GetTrad id="popupbtn" lang={props.lang} /></a>}
					<p className="popup-content-text robotoregular" dangerouslySetInnerHTML={ {__html: text} }></p>
				</div>
			</div>
		</React.Fragment>
	)
}

export default Popup;